import { DwQueryRequest } from '@fabric-ui/components';

export const LOGS_QUERY_PREFIX = 'LogsPrefix';

const createLogsQueryKey = (queryName: string, ...parts: unknown[]) => [LOGS_QUERY_PREFIX, queryName, ...parts] as const;

export const logsDashboardQueryKeys = {
  all: [LOGS_QUERY_PREFIX] as const,
  advanced: (searchQuery: string, projectionTable: string, range: [Date, Date], lastSearch?: Date) =>
    createLogsQueryKey('AdvancedLogsQuery', searchQuery, projectionTable, range, lastSearch),

  search: (query: DwQueryRequest, lastSearch?: Date) => createLogsQueryKey('SearchLogsQuery', query, lastSearch),
  totals: (query: DwQueryRequest, lastSearch?: Date) => createLogsQueryKey('SearchLogsTotalsQuery', query, lastSearch),
  pie: (query: DwQueryRequest, lastSearch?: Date) => createLogsQueryKey('SearchLogsPieQuery', query, lastSearch),
  histogram: (query: DwQueryRequest, lastSearch?: Date) => createLogsQueryKey('SearchLogsHistogramQuery', query, lastSearch),
} as const;
